<template>
 
  <div class="container" style=" margin-top: 218px; "  @scroll="handleScroll">
    
    <div style="position: relative; /* 相对定位 */
  z-index: 1; /* 设置较高的z-index，确保在背景图之上 */">

   
    <div class="about-top" >
      <h1>资管智谷，联盟共赢！</h1>
      <p>欢迎相关机构加入宽客资管联盟，共享资源，共同发展。</p>
      <!-- <button
      class="gsap-button"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      ref="button"
    >
      立即加入
    </button> -->
     <GSAPbutton>立即加入</GSAPbutton>
    </div>
    <div class="about-top_right">
      <p style="padding-top: 16px;">宽客资管联盟成立于2024年12月29日，<span style="color:#002E83;">{{this.textone}}。</span></p>
      <p>宽客资管联盟是一个金融科技与资产管理的创新融合平台。</p>
      <p>宽客资管联盟以为资管机构对接资金方，为资金方对接资管机构为具体任务。促进资金与技术的完美结合。</p>
      <div class="about-top_right_content">
      <img src=".././/../assets/images/components/aboutlogo.png" width="123px" height="40px" alt="">
      <p style="color: #002E83;" >宽客资管联盟是一个汇聚量化投资与资产管理领域专业人士、机构的高端行业组织，以推动量化投资与资产管理行业的发展为使命。</p>
      
    </div>  
    <span class="unlike">ABOUT US</span>
  </div>
  <div class="about-major" >
    <img src=".././/../assets/images/components/In about.png" alt="">
    <div class="about-major-text">
    <h1>来自全球</h1>
    <p>联盟成员将来自全球各地，涵盖资深量化投资专家、前沿技术开发者、大型资管机构、金融科技公司等。成员凭借深厚的金融知识、精湛的量化模型构建能力及敏锐的市场洞察力，为联盟发展注入强大动力。</p>
    <p style="color: #7E7F83">在投资策略研发上，联盟聚焦前沿量化技术，如机器学习、深度学习在投资中的应用，挖掘市场规律，构建多策略投资体系，应对复杂多变的市场。在风险管理方面，联盟成员共同研发先进风险评估模型，实时监控风险，确保投资组合稳定。</p>
  </div>
  </div>
    <div class="about-major_SS">
      <div class="about-major-text_SS">
        <h1>发展</h1>
        <p>同时，联盟高度重视人才培养与行业交流。定期举办研讨会、培训课程，邀请业内大咖分享经验，为从业者提供学习成长平台。还积极与监管机构沟通，推动行业规范发展，为成员营造良好政策环境。</p>
        <p style="color: #7E7F83">宽客资管联盟致力于成为全球领先的量化投资与资产管理行业平台，助力成员提升竞争力，推动行业创新发展。</p>
      </div>
      <img src=".././/../assets/images/components/In abouts.png" alt="">
    </div>
  </div>

  <svg style="display: none;">
        <defs >
          <filter id="noise" color-interpolation-filters="linearRGB" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse">
            <feTurbulence type="fractalNoise" baseFrequency="0 0.4" numOctaves="2" seed="2" stitchTiles="stitch" x="0%" y="0%" width="100%" height="100%" result="turbulence"/>
            <feDisplacementMap in="SourceGraphic" in2="turbulence" scale="10" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" result="displacementMap"/>
          </filter>
        </defs>
      </svg>
    
  </div>
  </template>
  
  <script>
import { gsap } from "gsap/dist/gsap";
import GSAPbutton from "@/utils/GSAPbutton.vue";
  export default {
  
    components: {
     GSAPbutton
    },
    data() {
    return {
      showSvg: false,
      canPlay: true, // 添加一个标志
      textone:'由成都多家资管机构牵头发起成立',
      enterAngle: 0, // 用来存储鼠标进入时的角度
    };
  },
  mounted() {
    
    this.animateEffect()
     // 添加滚动事件监听器
     window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
  //   handleMouseEnter(event) {
  //     const button = this.$refs.button;
  //     const rect = button.getBoundingClientRect();
  //     const x = event.clientX - rect.left;
  //     const y = event.clientY - rect.top;
  //     const width = button.offsetWidth;
  //     const height = button.offsetHeight;

  //     // 计算鼠标进入按钮时的角度
  //     const angle = Math.atan2(y - height / 2, x - width / 2);
  //     this.enterAngle = (angle + Math.PI) / (2 * Math.PI); // 将角度转化为 0-1 的值

  //     // 将角度转换为 360 度，并使用 GSAP 动画填充颜色
  //     const angleDeg = this.enterAngle * 360;

  //     gsap.to(button, {
  //       background: `linear-gradient(${angleDeg}deg, white, #55A5FA)`, // 根据鼠标角度动态填充背景
  //       duration: 1.2,
  //       ease: "power2.out",
  //       backgroundSize: "200% 200%", // 扩大背景区域
  //       scaleX: 1.1,
  //       scaleY: 1.1,
       
  //     });
  //   },
  //   handleMouseLeave() {
  //     const button = this.$refs.button;
      
  //     // 使用 GSAP 动画让颜色沿着原来的路径退出
  //     gsap.to(button, {
  //       background: `linear-gradient(${this.enterAngle * 360}deg, white,white)`, // 沿着进入时的角度退出
  //       backgroundSize: "100% 100%", // 恢复背景大小
  //       duration: 1.2,
  //       ease: "power2.out",
  //       scaleX: 1,
  //       scaleY: 1,
  //     });
  //   }
  // ,
    animateEffect() {
      const fe = document.querySelector('feTurbulence');
      const tl = gsap.timeline({
        paused: true,
        onUpdate() {
          fe.setAttribute('baseFrequency', `0 ${val.n}`);
        },
        onComplete: () => {
          this.canPlay = true; // 动画完成后重置标志
        }
      });

      const val = { n: 0.04 };
      tl.to(val, { n: 0.00001, duration: 0.2 });
      tl.to(val, { n: 0.04, duration: 0.2 });
      tl.to(val, { n: 0.0001, duration: 0.2 });
      
      // 启动动画
      tl.play();
    },
    handleScroll() {
      // 检查是否滚动到底部
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        this.showSvg = true;
        this.animateEffect(); // 调用动画效果
      }
    }
  }
};
  
  </script>
  
  <style>
  .TAU{
    width: 136px;
    margin: 90px 0px  0px 166px;
height: 45px;
font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 700;
font-size: 32px;
color: #1D2129;
line-height: 45px;
text-align: left;
font-style: normal;
text-transform: none;
position: absolute;
  }
  .TAU_en{
    margin: 140px 0px  0px 166px;
    font-size: 14px;
color: #004AB5;
position: absolute;
  }
.about-img{
padding-top: 70px;
padding-bottom: 95px;
margin-left: 140px;
}
.about-top{
  width: 1046px;
height: 191px;

background: #55A5FA;
border-radius: 4px 4px 4px 4px;
margin: auto;
background-color: rgba(85, 165, 250, 0.9);
}
.about-top h1{
    width: 200px;
height: 28px;
font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 700;
font-size: 20px;
color: #FFFFFF;
line-height: 28px;
text-align: left;
font-style: normal;
text-transform: none;
  padding: 20px 20px 12px 20px;
}
.about-top p{
  width: 544px;
height: 22px;
font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 400;
font-size: 16px;
color: #FFFFFF;
line-height: 22px;
text-align: justify;
font-style: normal;
text-transform: none;
padding: 0px 0px 44px 20px;
}

.about-top_right{
  width: 570px;
height: 195px;
background: #FFFFFF;
border-radius: 4px 4px 4px 4px;
position: relative;
margin-left: 624px;
margin-top: -224px;

background-color: rgba(255, 255, 255, 0.9); 
}
.about-top_right p{
  width: 504px;
height: 17px;
font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 400;
font-size: 12px;
color: #7E7F83;
line-height: 17px;
text-align: justify;
font-style: normal;
text-transform: none;
padding-left: 16px;
padding-bottom: 12px;
}

.about-top_right_content{
  display: flex;
   padding-left: 16px;
  padding-top: 16px;
  
}
.about-top_right_content p{
  width: 359px;
height: 34px;
padding-left: 20px;
}
.unlike {
  transform: rotate(90deg);
  position: absolute;
width: 190px;
            font-weight: 700;
          font-size: 32px;
          line-height: 45px;
          margin-left: 450px;
          margin-top: -80px;
            background: linear-gradient(90deg, #55A5FA, #FFFFFF); /* 渐变效果 */
           -webkit-background-clip: text; /* 文字背景剪裁 */
         -webkit-text-fill-color: transparent; /* 文字填充透明 *
            height: 320px; /* 高度 */
      
}
/* .about-top button {
  width: 120px;
  height: 36px;
  background: white; 
  border-radius: 2px;
  border: 2px solid transparent; 
  margin-left: 20px;
  color: #55A5FA; 
  border: none;
  cursor: pointer; 
  transition: background 0.3s ease, transform 0.3s ease; 
} */

.about-top button:hover {
  background: white; /* 悬停时的背景颜色 */
  transform: scale(1.05); /* 悬停时放大 */
  border: 2px solid #55A5FA;; /* 初始边框透明 */
}

.about-top button:active {
  transform: scale(0.95); /* 点击时缩小 */
}
.about-major,.about-major_SS{
  margin-left: 140px;
  padding-top: 58px;
  display: flex;
}
.about-major img ,.about-major_SS img {
  filter: url(#noise);
  
}
.about-major h1,.about-major_SS h1{
  font-size: 20px;
color: #1D2129;
padding-top: 138px;
}
.about-major-text{
  width: 454px;
  justify-content: space-around;
  padding-left: 32px;
}
.about-major-text p{
  font-weight: 400;
font-size: 14px;
padding-top: 12px;
}
.about-major-text_SS{
  width: 454px;
  justify-content: space-around;
  padding-right: 32px;
}
.about-major-text_SS p{
  font-weight: 400;
font-size: 14px;
padding-top: 12px;
}
.header-background {
  background-image: url('.././/../assets/images/components/base.png '); /* 设置背景图 */
  background-size: cover; /* 背景图覆盖整个容器 */
  background-position: center; /* 背景图居中 */
  height: 450px; /* 设置高度，根据需要调整 */
 width: 100%;
 position: absolute;
  margin-bottom: 170px;
  z-index: 1;
  
}
/* .gsap-button {
  width: 120px;
  height: 36px;
  background: white; 
  border-radius: 2px;
  border: 2px solid transparent; 
  margin-left: 20px;
  color: #55A5FA; 
  border: none;
  cursor: pointer; 
  
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.gsap-button:focus {
  outline: none;
} */
  </style>